import React from "react";
import State from "../renderless/state";
import PropTypes from "prop-types";

const FormManager = ({ data, disableFunc, render, children, onSubmit }) => {
  return (
    <State
      initialState={data}
      render={({ state, setState }) => {
        const disable_func_result = disableFunc(state);
        // old version only returned booleans, so this code is to maintain compatability
        const is_obj = typeof disable_func_result === "object";
        const is_disabled = is_obj ? disable_func_result.isDisabled : disable_func_result;
        const errors = is_obj ? disable_func_result.errors : {};
        const renderProp = typeof render === "function" ? render : children;

        const doTheSubmit = () => {
          onSubmit(state, setState);
        };

        return renderProp({
          state,
          setState,
          errors,
          isDisabled: is_disabled,
          handleSubmit: doTheSubmit,
        });
      }}
    />
  );
};

FormManager.propTypes = {
  data: PropTypes.object,
  disableFunc: PropTypes.func,
  children: PropTypes.func,
  render: PropTypes.func,
  onSubmit: PropTypes.func,
};
FormManager.displayName = "FormManager";
export default FormManager;
